import { UserAccountMenuComponent } from '../../shared/widgets/kite/user-account-menu/user-account-menu.component';
import { NgModule } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { HeaderComponent } from './header/header.component';
import { NotificationDropdownComponent } from '../../shared/components/notification-dropdown/notification-dropdown.component';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [
    BreadcrumbsComponent,
    SidebarComponent,
    HeaderComponent,
    NotificationDropdownComponent,
  ],
  imports: [
    CommonModule,
    UserAccountMenuComponent,
    LucideAngularModule,
    RouterModule,
    FormsModule,
    PipesModule,
  ],
  exports: [
    BreadcrumbsComponent,
    SidebarComponent,
    HeaderComponent,
    NotificationDropdownComponent
  ]
})
export class SharedModule { }
